import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Brand } from '../../../models/brand.model';
import { BrandService } from './../../../services/brand/brand.service';


@Component({
  selector: 'app-brand-form',
  templateUrl: 'brandForm.html',
  styles: ['label.required:after {top: 0} .ui-grid-row {margin-bottom: 7px}']
})

export class BrandFormComponent implements OnChanges, OnInit {
  @Output() brandAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() brandUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogBoxBrand: Brand;
  addEditForm: FormGroup;
  invalidSubmit: boolean;
  validation: any;

  constructor(private fb: FormBuilder, private srvBrand: BrandService) {}

  ngOnInit(): void {
    this.loadValidation();
  }

  loadValidation() {
    this.srvBrand.getFields().subscribe(res => {
      this.validation = res;
    });
  }

  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
        'code': new FormControl(this.dialogBoxBrand.code),
        'name': new FormControl(this.dialogBoxBrand.name),
        'logo': new FormControl(this.dialogBoxBrand.logo)
    });
  }

  saveOrUpdate(): void {
     if (!this.addEditForm.valid) {
       this.invalidSubmit = true;
       return;
     }

    let newData = Object.assign({}, this.dialogBoxBrand, this.addEditForm.value);
    if (newData.id == null) {
      this.brandAdded.emit(newData);
    } else {
      this.brandUpdated.emit(newData);
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/brand/brandForm.component.ts